import { loadLayoutsByBookId } from './../actions/entities/layouts';
import { loadPlaceholdersByBookId } from './../actions/entities/placeholders';
import { loadBackgroundPlaceholderByBookId } from './../actions/entities/backgroundPlaceholders';
import { loadCoverDetailsByBookId } from './../actions/entities/cover';

import {
  loadBookBackgroundType,
  loadEditorBookProperties,
} from './../actions/ui/bookProperties';
import { loadAutoFill } from './../actions/ui/setAutoFill';
import { loadTextsByBookId } from './../actions/entities/texts';
import { loadBookContext, addBookId, addFolderId, addDefaultText, loadParentStyle } from './../actions/bookproperties';
import { isSavedBook } from '../actions/ui/isSavedBook';
import { loadPagesByBookId } from '../actions/entities/pages';
import { loadBackgrounds } from '../actions/backgrounds';
import { loadPageToViewed } from '../actions/ui/addPageToViewed';

export function loadBookPartials(json, dispatch) {
  const {
    entities, bookProperties, editorUI, backgrounds,
  } = json;
  dispatch(loadPagesByBookId(entities.pages));
  dispatch(loadBackgrounds(backgrounds.backgrounds, true));
  dispatch(addBookId(bookProperties.productID));
  dispatch(addFolderId(bookProperties.folderId));

  // Some products have default text property
  if ('defaultText' in bookProperties) {
    dispatch(addDefaultText(bookProperties.defaultText));
  }

  if ('parentStyle' in bookProperties) {
    dispatch(loadParentStyle(bookProperties.parentStyle));
  }

  // Book properties, pages, layouts and placeholders
  dispatch(loadBookContext(bookProperties.context));
  dispatch(loadLayoutsByBookId(entities.layouts));
  dispatch(loadPlaceholdersByBookId(entities.placeholders));

  // load BackgroundPlaceholder if exist
  if (entities.backgroundPlaceholders !== undefined) {
    dispatch(loadBackgroundPlaceholderByBookId(entities.backgroundPlaceholders));
  }
  // load texts
  if (entities.texts) {
    dispatch(loadTextsByBookId(entities.texts));
  }

  // editorUI
  dispatch(loadBookBackgroundType(editorUI.bookProperties));
  dispatch(loadPageToViewed(editorUI.addPageToViewed));
  dispatch(loadAutoFill(editorUI.setAutoFill));
  dispatch(loadEditorBookProperties(editorUI.bookProperties));


  // Cover Details
  dispatch(loadCoverDetailsByBookId(entities.cover));

  dispatch(isSavedBook(true));
}



// WEBPACK FOOTER //
// ./src/redux/helpers/loadBook.js